/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { Checkbox as ConsumerCheckbox, CheckboxProps as ConsumerCheckboxProps } from '@blend/consumer-components';
import { useConsumerTheme } from '../../../../hooks/useConsumerTheme';

export namespace Checkbox {
  export interface Props extends Omit<ConsumerCheckboxProps, 'color'> {
    required?: boolean;
  }
}

export const Checkbox: React.FC<Checkbox.Props> = ({ ...props }) => {
  const {
    appConfig: { colors },
  } = useConsumerTheme();
  return <ConsumerCheckbox {...props} color={colors.action} />;
};
